module.exports = __webpack_public_path__ + "img/risk-explanation.d3f19035.png";